// Vendor
import { createSelector } from '@ngrx/store';
// Selectors
import { getChartState } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart-base.selectors';
export const getChartZoomExtremes = createSelector(getChartState, (chartState) => {
    return chartState.axisExtremes;
});
